module.exports = __webpack_public_path__ + "img/index-2.48e1b70a.png";